import axios from 'axios';
import request from './request.js'
import Vue from 'vue'


request.init();

function Setcookie(name, value) {
  //设置名称为name,值为value的Cookie
  var expdate = new Date(); //初始化时间
  expdate.setTime(expdate.getTime() + 48 * 30 * 60 * 1000); //时间单位毫秒
  document.cookie =
    name + "=" + value + ";expires=" + expdate.toGMTString() + ";path=/;domain=";
  //即document.cookie= name+"="+value+";path=/";  时间默认为当前会话可以不要，但路径要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！
}
// Warn if overriding existing method
if (Array.prototype.equals)
  console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
  // if the other array is a falsy value, return
  if (!array)
    return false;
  // compare lengths - can save a lot of time
  if (this.length != array.length)
    return false;
  for (var i = 0, l = this.length; i < l; i++) {
    // Check if we have nested arrays
    if (this[i] instanceof Array && array[i] instanceof Array) {
      // recurse into the nested arrays
      if (!this[i].equals(array[i]))
        return false;
    } else if (this[i] != array[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
}
// Hide method from for-in loops
//js格式化函数 日期
Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1,// month
    "d+": this.getDate(),// day
    "h+": this.getHours(),// hour
    "m+": this.getMinutes(),// minute
    "s+": this.getSeconds(),// second
    "q+": Math.floor((this.getMonth() + 3) / 3),// quarter
    "S": this.getMilliseconds()
    // millisecond
  };
  if (/(y+)/.test(format) || /(Y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};
//js格式化函数

Object.defineProperty(Array.prototype, "equals", {enumerable: false});

function GetDate(AddDayCount) {
  var dd = new Date();
  dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期
  dd.setHours(0);
  dd.setMinutes(0);
  dd.setSeconds(0);
  return dd;
}


function fixedTo10(s) {
  return s < 10 ? '0' + s : s;
}


function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2]);
  } else {
    return "";
  }
}


function getStamp(val) {
  var data2 = val;
  data2 = data2.substring(0, 19);
  data2 = data2.replace(/-/g, '/');
  return new Date(data2).getTime();
}

function getUrlKey(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}


function  getImageHeight() {
        if(    document.getElementsByClassName('el-carousel__item')[0].children[0].children[0].clientHeight!=0){
          return     document.getElementsByClassName('el-carousel__item')[0].children[0].children[0].clientHeight;
        }else{

        }
}

function  checkImg(imgurl){
  console.log(imgurl);
  var url = imgurl;
  var img = new Image();
  setInterval(function () {
    // console.log(document.getElementsByClassName('el-carousel__container')[0].children[3].clientHeight);
    // console.log(document.getElementsByClassName('el-carousel__item')[0].children[0].children[0].clientHeight);
    // console.log(img.width);
  },100)

  img.src = url;
  if(img.complete||img.width) {
    console.log('有缓存');
    setTimeout(function () {
      var myEvent = new Event('resize');
      window.dispatchEvent(myEvent);
    },50)
  }else{
    console.log('无缓存');
   // let time= setInterval(function () {
   //       if(document.getElementsByClassName('el-carousel__item')[0].children[0].children[0].clientHeight!=0){
   //         setTimeout(function () {
   //           var myEvent = new Event('resize');
   //           window.dispatchEvent(myEvent);
   //         },50)
   //         clearInterval(time);
   //       }
   //  },100);
    //
    // setTimeout(function () {
    //   var myEvent = new Event('resize');
    //   window.dispatchEvent(myEvent);
    // },200)
  }
}

function compileStr(code) {  //加密
  var a = String.fromCharCode(code.charCodeAt(0) + code.length);
  for (var i = 1; i < code.length; i++) {
    a += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  }
  return escape(a);
}

function uncompileStr(code) {//解密
  code = unescape(code);
  var c = String.fromCharCode(code.charCodeAt(0) - code.length);
  for (var i = 1; i < code.length; i++) {
    c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  }
  return c;

}


function checkPower(str) {

  if (Vue.POWER.indexOf(str) > -1) {
    return true;
  } else {
    return false;
  }
}

export {
  checkPower,
  GetDate,
  getCookie,
  getStamp,
  fixedTo10,
  Setcookie,
  compileStr,
  uncompileStr,
  getUrlKey,
  checkImg,
  getImageHeight,
}



// WEBPACK FOOTER //
// ./src/common/common.js